module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/interface/media-skip-a2d0e7490110f5c7402b2b658d068075.svg";